import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface UnlockOnboardingPayload {
  company_id: string;
}

interface UnlockOnboardingResponse {
  company_id: string;
  previous_onboarding_date: number | null; // The onboarding the unlock just erased, null when the company never had one
}

async function unlockOnboarding(
  payload: UnlockOnboardingPayload,
  auth: Authentication
): Promise<UnlockOnboardingResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/backoffice/onboarding-unlock',
      payload,
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('unlockOnboarding error:', e);
    throw new UnlockOnboardingFailure(e.message);
  }
}

export class UnlockOnboardingFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default unlockOnboarding;
